import React, { Component, Fragment } from 'react';
import { connect } from 'formik';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import Calendar from '../../components/calendar/calendar.component.js';

import CheckoutService from './checkout.service.js';

import './availability.step.scss';

const Time = ({ time, selectedTime, onTimeClick }) => (
	<div
		className={cn('time', { selected: moment(time).format('HH:mm') === selectedTime })}
		onClick={() => onTimeClick(moment(time).format('HH:mm'), time.id)}
	>
		{`${time.hour}:${time.minutes}`}
	</div>
);

class AvailabilityStep extends Component {
	constructor(props) {
		super(props);
		this.scheduleRef = React.createRef();
		this.state = {
			dates: null,
			isLoadingDates: true,
			hasError: false,
		};
	}

	componentDidMount() {
		this.setInterval();
	}

	componentWillUnmount() {
		const { handleInfoMessage } = this.props;

		handleInfoMessage({});
	}

	setInterval = () => {
		const { formik: { values } } = this.props;

		if (!values.schedule.day) {
			this.fetchAvailability(this.interval(moment()));
		} else {
			this.fetchAvailability(this.interval(moment(values.schedule.day)));
		}
	};

	interval(date) {
		let startDate = moment(date)
			.startOf('month')
			.startOf('isoWeek');

		const monthStartDate = moment(date)
			.startOf('month');

		if (monthStartDate.isBefore(startDate)) {
			startDate = moment(date)
				.startOf('month')
				.startOf('isoWeek');
		}

		const endDate = moment(date)
			.endOf('month')
			.endOf('isoWeek');


		return {
			starts: startDate,
			ends: endDate,
		};
	}

	fetchAvailability(datesInterval) {
		const { formik: { values, setFieldValue }, handleInfoMessage, intl } = this.props;
		const { dates } = this.state;

		this.setState({ isLoadingDates: true });

		const ticketsAmount = values.prices.reduce(
			(accumulator, currentValue) => accumulator + currentValue.quantity,
			0,
		);


		CheckoutService.getAvailability(datesInterval.starts, datesInterval.ends, ticketsAmount, values.id)
			.then((receivedDates) => {
				let newDates = null;
				if (!dates) {
					newDates = receivedDates;
					if (values.schedule.day || (values.schedule.day && values.schedule.time)) {
						const foundDay = receivedDates.find(e => moment(e.day).isSame(values.schedule.day, 'day'));
						if (!foundDay || (values.schedule.time && !foundDay.sessions.find(session => `${session.hour}:${session.minutes}` === values.schedule.time))) {
							handleInfoMessage({
								message: intl.formatMessage({ id: 'checkout.information.availability.not-available' }),
								type: 'info',
							});
							setFieldValue('schedule[day]', null);
							setFieldValue('schedule[time]', null);
							setFieldValue('schedule[session]', null);
						}
					}
				} else {
					newDates = dates;
					receivedDates.forEach((receivedDate) => {
						const index = newDates.findIndex(date => date.day === receivedDate.day);
						if (index === -1) {
							newDates.push(receivedDate);
						} else {
							newDates[index] = receivedDate;
						}
					});
				}
				this.setState({ isLoadingDates: false, dates: newDates });
			})
			.catch((error) => {
				this.setState({ isLoadingDates: false, hasError: error });
			});
	}

	handleMonth = (date) => {
		this.fetchAvailability(this.interval(date));
	};

	handleDayClick = (date) => {
		const { formik: { setFieldValue, setFieldTouched }, handleInfoMessage } = this.props;
		setFieldValue('schedule[day]', date);
		setFieldValue('schedule[time]', null);
		setFieldValue('schedule[session]', null);
		setFieldTouched('date');
		handleInfoMessage({});
		window.scrollTo({
			top: (this.scheduleRef.current.offsetTop - 300),
			behavior: 'smooth',
		});
	};

	handleTimeClick = async (time, id) => {
		const { formik: { setFieldValue, setFieldTouched, values }, handleInfoMessage, intl: { formatMessage } } = this.props;
		setFieldValue('schedule[time]', time);
		setFieldValue('schedule[session]', id);
		setFieldTouched('time');


		const extras = await CheckoutService.getExtrasFromSession(id);
		const errors = [];

		values.extras.forEach((extra, index) => {
			const foundExtra = extras.find(e => e.id === extra.id);
			let capacity = 0;
			if (foundExtra && foundExtra.capacity) {
				capacity = foundExtra.capacity;
			}
			if (extra.oldQuantity) {
				if (extra.oldQuantity < capacity) {
					const newExtra = Object.assign({}, extra);
					newExtra.quantity = extra.oldQuantity;
					delete newExtra.oldQuantity;
					setFieldValue(`extras[${index}]`, newExtra);
				} else {
					errors.push(`${capacity} ${extra.name}`);
					setFieldValue(`extras[${index}][quantity]`, capacity);
				}
			} else if (extra.quantity > capacity) {
				errors.push(`${capacity} ${extra.name}`);
				setFieldValue(`extras[${index}][oldQuantity]`, extra.quantity);
				setFieldValue(`extras[${index}][quantity]`, capacity);
			}
		});

		if (errors.length > 0) {
			handleInfoMessage({
				message: formatMessage({ id: 'checkout.error.extras.availability' }, { extras: errors.join(', ') }),
				type: 'error',
			});
		}
	};

	render() {
		const {
			formik: { values },
			intl,
		} = this.props;

		const { isLoadingDates, dates } = this.state;

		let sessions = null;
		if (dates && values.schedule.day) {
			sessions = dates.find(date => moment(date.day).format('YYYY-MM-DD')
				=== moment(values.schedule.day).format('YYYY-MM-DD'));
		}
		return (
			<div className="availability row center-xs start-md">
				<div className="col-xs-12">
					<div className="container">
						<h3>{intl.formatMessage({ id: 'checkout.availability.title' })}</h3>

						<Calendar
							selectedDate={values.schedule.day}
							onDayClick={this.handleDayClick}
							schedule={dates}
							isLoading={isLoadingDates}
							handleMonth={this.handleMonth}
							setInterval={this.setInterval}
						/>

						<div className="schedule" ref={this.scheduleRef}>
							{values.schedule.day && (
								<Fragment>
									<span className="schedule-title">{intl.formatMessage({ id: 'checkout.availability.schedule' })}</span>
									<div className="time-blocks">
										{dates && sessions && sessions.sessions.map(timeBlock => (
											<Time
												key={timeBlock}
												time={timeBlock}
												selectedTime={values.schedule.time}
												onTimeClick={this.handleTimeClick}
											/>
										))}
									</div>
								</Fragment>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(connect(AvailabilityStep));
